import {takeEvery} from 'redux-saga/effects'

import {
  FORGOT_PASSWORD,
  REQUEST_PASSWORD_RESET_OTP,
  RESET_DEFAULT_PASSWORD,
  RESET_PASSWORD,
  VERIFY_PASSWORD_RESET_GOOGLE,
  VERIFY_PASSWORD_RESET_OTP,
} from '../../Actions/SignIn/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(FORGOT_PASSWORD, fetchData)
  yield takeEvery(REQUEST_PASSWORD_RESET_OTP, fetchData)
  yield takeEvery(VERIFY_PASSWORD_RESET_OTP, fetchData)
  yield takeEvery(VERIFY_PASSWORD_RESET_GOOGLE, fetchData)
  yield takeEvery(RESET_PASSWORD, fetchData)
  yield takeEvery(RESET_DEFAULT_PASSWORD, fetchData)
}

export default dataSaga
